import { FC, SVGProps } from 'react'

const PinIcon: FC<SVGProps<SVGSVGElement>> = svgProps => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...svgProps}
  >
    <path
      d="M12.4557 5.86999L10.4792 3.89158C9.12806 2.53915 8.45253 1.86293 7.72693 2.023C7.0014 2.18308 6.6724 3.08091 6.01446 4.87659L5.56915 6.09195C5.39375 6.57066 5.30605 6.81001 5.14826 6.99516C5.07746 7.07824 4.9969 7.15246 4.90834 7.21622C4.71096 7.35835 4.4654 7.42601 3.9743 7.56141C2.86738 7.86655 2.31392 8.01915 2.10536 8.38128C2.0152 8.53781 1.96828 8.71555 1.96942 8.89628C1.97206 9.31421 2.37798 9.72055 3.18984 10.5332L4.1329 11.4774L1.14896 14.4641C0.950345 14.6629 0.950345 14.9853 1.14896 15.1841C1.34758 15.3829 1.66962 15.3829 1.86824 15.1841L4.85227 12.1973L5.8296 13.1755C6.6466 13.9933 7.05513 14.4023 7.4756 14.4029C7.6528 14.4031 7.82693 14.3571 7.98086 14.2693C8.34613 14.0608 8.49953 13.5033 8.80633 12.3882C8.94126 11.898 9.00866 11.6529 9.15026 11.4555C9.21226 11.3692 9.28413 11.2904 9.36453 11.2208C9.54806 11.0619 9.78586 10.9725 10.2615 10.7939L11.4908 10.3319C13.2667 9.66475 14.1546 9.33115 14.3111 8.60755C14.4676 7.88388 13.7969 7.21258 12.4557 5.86999Z"
      fill="currentColor"
    />
  </svg>
)

export default PinIcon
